<template>
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.risk_assessment') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.risk_assessment') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_system" @click.prevent="addSystem">{{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="Risikobewertung"
            fileName="System"
            modelName="riskanalysis"
            deleteURL="todos/v1/delete_risk_analysis/"
            :editorPatchURL="editorPatchURL"
            :columns="columns"
            :objects="riskAnalysisList"
            :exportColumns="[0, 1]"
            :extraActions="extraActions"
            :editorCallback="true"
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showRiskAnalysis"
            @callDrawback="drawCallbackFunctions"
            @editorUpdated="setRiskAnalysis"
            v-if="promiseFinished"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </diV>

    <!--modal section starts here-->
    <RiskAnalysisComponent :bsi-groups="bsiGroups" :dsgvo-groups="dsgvoGroups" :verbose-names="verboseName" :help-text="help_text" :risk-analysis="currentRiskAnalysis" @riskAnalysisUpdated="setRiskAnalysis" @simpleRiskAnalysis="triggerSimpleRiskAnalysis">
      <template v-slot:comments><comments :commentObject="currentRiskAnalysis" modelName="riskanalysis" @commentUpdated="setRiskAnalysis" modelVerboseName="RiskAnalysis"></comments></template>
    </RiskAnalysisComponent>

    <task :currentTodo="currentTodo" origin="riskanalysis">
      <template v-slot:steps>
        <Steps
          :totalSteps="currentTodo.steps"
          :taskID="currentTodo.id"
          @stepsUpdated="setSteps"
        ></Steps>
      </template>
    </task>

    <SimpleRiskAnalysis survey-title="Einfache Risikobewertung" :survey-json="surveyBody" @simpleRiskAnalysisCompleted="updateSimpleRiskAnalysis" :risk-analysis="currentRiskAnalysis"></SimpleRiskAnalysis>

  </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
import service from '@/utils/request.js';
import {deepCopy} from '@/utils/index.js';
import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
import {newTodo, objectModalName, newSystem, newSupplier, newRiskAnalysis, newVT} from "@/utils/enums";
import task from "@/components/component/TodoComponent.vue";
import comments from "@/components/component/CommentComponent.vue";
import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
import RiskAnalysisComponent from "@/components/component/RiskAnalysisComponent.vue";
import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
import Steps from "@/components/component/Steps.vue";
import SimpleRiskAnalysis from "@/components/component/SimpleRiskAnalysisComponent.vue";

  export default {
    components: {
      SimpleRiskAnalysis,
      Steps,
      FingerPrintSpinner,
      DisplayColumnsComponent,
      RiskAnalysisComponent,
      task, DataTableDSMS, comments},
    data() {
      return {
        riskAnalysisList: [],
        currentRiskAnalysis: {},
        surveyBody: {},
        currentVT: newVT,
        table: null,
        editor: null,
        promiseFinished: false,
        editorPatchURL: '/todos/v1/patch_risk_analysis/',
        bsiGroups: [],
        dsgvoGroups: [],
        verboseName: {},
        help_text: {},
        baseColumns: [
          {
            label: 'Nr.#',
            name: 'sequence',
            enableEditor: false,
            definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
          },
          {
            label: 'VT',
            name: 'vt',
            enableEditor: false,
            definition: { data: "vt_detail.name" },
          },
          {
            label: 'Grund der Risikobewertung',
            name: 'reason',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "reason" },
          },
          {
            label: 'Beschreibung',
            name: 'description',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "description" },
          },
          {
            label: 'Ergebnis',
            name: 'risk_level',
            enableEditor: false,
            definition: { data: "risk_level" },
          },
        ],
        currentTodo: {},
      }
    },
    async created() {
      await this.getRiskAnalysis()
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, user: state => state.user, account: state => state.account, departments: state => state.account.departments, suppliers: state => state.account.suppliers}),
      ...mapGetters(['selectDepartmentOptions', 'selectSupplierOptions']),
      columns() {
        let newColumns = deepCopy(this.baseColumns)
        if (this.dsgvoGroups.length > 0 && this.bsiGroups.length > 0) {
          newColumns.push({
            label: 'Einfache Bewertung (IT)',
            name: 'bsi_basis',
            enableEditor: true,
            type: 'text',
            attr: {
              placeholder: 'Einfache Bewertung (BSI Grundschutz)',
              type: 'number',
            },
            definition: { data: "bsi_basis", className: 'dkl-bg-lightblue' },
          })
          newColumns.push({
            label: 'Einfache Bewertung (Datenschutz)',
            name: 'dsgvo_basis',
            enableEditor: true,
            type: 'text',
            attr: {
              placeholder: 'Einfache Bewertung (DSGVO)',
              type: 'number',
            },
            definition: { data: "dsgvo_basis", className: 'dkl-bg-lightblue' },
          })
          newColumns.push({
            label: 'Maximaler Wert (BSI Grundschutz)',
            enableEditor: false,
            definition: { data: null, render: (data, type, row, meta) => {
              let bsiValueList = [];
              this.bsiGroups.forEach((group) => {
                bsiValueList.push(row[group])
              })
              return Math.max(...bsiValueList)
              }, className: 'dkl-bg-lightgrey dkl-border-left'},
          })
          this.bsiGroups.forEach((group) => {
            newColumns.push({
              label: this.verboseName[group],
              name: group,
              enableEditor: true,
              type: 'text',
              attr: {
                placeholder: this.verboseName[group],
                type: 'number',
              },
              definition: { data: group, className: 'dkl-bg-lightgrey' },
            })
          })
          newColumns.push({
            label: 'Maximaler Wert (DSGVO)',
            enableEditor: false,
            definition: { data: null, render: (data, type, row, meta) => {
              let dsgvoValueList = [];
              this.dsgvoGroups.forEach((group) => {
                dsgvoValueList.push(row[group])
              })
              return Math.max(...dsgvoValueList)
              }, className: 'dkl-bg-lightcyan dkl-border-left'},
          })
          this.dsgvoGroups.forEach((group) => {
            newColumns.push({
              label: this.verboseName[group],
              name: group,
              enableEditor: true,
              type: 'text',
              attr: {
                placeholder: this.verboseName[group],
                type: 'number',
              },
              definition: { data: group, className: 'dkl-bg-lightcyan' },
            })
          })
        }
        return newColumns
      },
    },
    mounted() {
    },
    updated ()
    {
    },
    methods: {
      ...mapMutations({setEdit: 'SET_EDIT'}),
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
      },
      setSteps(steps) {
        this.currentTodo.steps = steps
      },
      triggerSimpleRiskAnalysis(vtID) {
        this.currentRiskAnalysis.vt = vtID
        this.openSimpleRiskSurvey()
      },
      openSimpleRiskSurvey() {
        service.get(`survey/v1/survey_by_name/?name=${encodeURIComponent("einfache Risikobewertung")}`).then(response => {
          this.surveyBody = response.data.body
          $('#' + objectModalName.riskSurvey).modal('show')
        }).catch(error => this.$vToastify.error(String(error)))
      },
      setRiskAnalysis(riskAnalysis) {
        this.currentRiskAnalysis = riskAnalysis
        const riskAnalysisIndex = this.riskAnalysisList.findIndex((riskAnalysis) => riskAnalysis.id === this.currentRiskAnalysis.id)
        if (riskAnalysisIndex > -1) {
          this.riskAnalysisList[riskAnalysisIndex] = riskAnalysis
        } else {
          this.riskAnalysisList.push(riskAnalysis)
        }
        if (this.table) {
          this.table.clear().rows.add(this.riskAnalysisList).draw()
        }
      },
      updateSimpleRiskAnalysis(surveyResult) {
        this.setRiskAnalysis(surveyResult.riskAnalysis)
        $('#' + objectModalName.riskSurvey).modal('hide')
        service.request({
          url: `todos/v1/patch_vt/${this.currentRiskAnalysis.vt}/`,
          method: 'PUT',
          responseType: 'json',
          data: {
            id: this.currentRiskAnalysis.vt,
            number_of_persons: surveyResult.numberOfPersons,
            data_type_category: surveyResult.dataTypeCategory,
            risk_level: surveyResult.riskAnalysis.risk_level
          }
        }).catch(function (err) {
          console.log(err)
        })
      },
      showRiskAnalysis(riskAnalysisID) {
        this.currentRiskAnalysis = this.riskAnalysisList.find((riskAnalysis) => riskAnalysis.id === riskAnalysisID)
        $('#' + objectModalName.riskAnalysis).modal('show');
      },
      extraActions(data) {
        return `<a class="dropdown-item related-task" href="#" data-risk-analysis-id="${data.id}">Verbundene Maßnahme</a><a class="dropdown-item add-task" href="#" data-risk-analysis-id="${data.id}">Maßnahme erstellen</a>`
      },
      drawCallbackFunctions() {
        const that = this
        $('.related-task').off('click').on('click', function(e) {
          e.preventDefault();
          let riskAnalysisID = $(e.target).data('risk-analysis-id');
          that.gotoTasks(riskAnalysisID)
        })
        $('.add-task').off('click').on('click', function(e) {
          e.preventDefault();
          const riskAnalysisID = $(e.target).data('risk-analysis-id');
          that.addTodo(riskAnalysisID)
        })
      },
      addTodo(riskAnalysisID) {
        this.currentTodo = deepCopy(newTodo)
        this.setEdit(true)
        this.currentTodo.object_id = riskAnalysisID
        this.currentTodo.model = 'riskanalysis'
        $('#' + objectModalName.task).modal('show');
      },
      gotoTasks(riskAnalysisID) {
        this.$router.push({name: 'massnahmenplan', params: {questionID: riskAnalysisID, questionDescription: riskAnalysisID.toString(), model: 'riskanalysis'}})
      },
      toggle_column(event, column_index) {
        // Get the column API object
        let column = $('.datatable').DataTable().column(column_index);

        // Toggle the visibility
        column.visible(!column.visible());

        // adjust dropdown menu
        if (column.visible() && !$(event.target).hasClass('selected')) {
          $(event.target).addClass('selected')
        } else if (!column.visible() && $(event.target).hasClass('selected')) {
          $(event.target).removeClass('selected');
        }
      },
      async getRiskAnalysis() {
        service.request({
          url: `todos/v1/risk_analysis/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.riskAnalysisList = response.data.results;
          this.bsiGroups = response.data.bsi_group;
          this.dsgvoGroups = response.data.dsgvo_group;
          this.verboseName = response.data.verbose_name;
          this.help_text = response.data.help_text;
          this.promiseFinished = true
        }).catch((err) => {
          console.log(err)
          this.promiseFinished = true
        })
      },
    }
  }
</script>
